// extracted by mini-css-extract-plugin
module.exports = {"noImage":"_02712f2b3b--noImage--naJHd","noImage-icon":"_02712f2b3b--noImage-icon--roK3n","noImage-text":"_02712f2b3b--noImage-text--x4cMI"};